
import React from "react";
import { Link } from "react-router-dom";

function Natures() {
  return (
    <>
      <section class="single section-sm pb-0">
        <div class="container">
          <div class="row">
            <div class="col-lg-12">
              <div class="p-lg-5 p-4 bg-white">
                <h2 class="mb-5">Natures</h2>
                <p>Each Evo a nature that increases the stat growth for one stat and descreases it for another.</p>
                <div class="content">
                <hr />
                <h5 class="mb-5">Nature Stat Growth Impact</h5>
                <p>More details coming soon!</p>
                <hr />
                <h5 class="mb-5">Nature List</h5>
                <p>More details coming soon!</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Natures;